import { createRedirectSession as publicCreateRedirectSession } from './headless-v1-redirect-session-redirects.public';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onRedirectSessionCreated as publicOnRedirectSessionCreated } from './headless-v1-redirect-session-redirects.public';
export const createRedirectSession = createRESTModule(publicCreateRedirectSession);
export { publicOnRedirectSessionCreated };
/** */
export const onRedirectSessionCreated = createEventModule(publicOnRedirectSessionCreated);
export { LocationType, Prompt, MembersAccountSection, Status, CallbackType, WebhookIdentityType, } from './headless-v1-redirect-session-redirects.universal';
//# sourceMappingURL=headless-v1-redirect-session-redirects.context.js.map